var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6267_1075)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6267_1075)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.377441,
    y: 0.376953,
    width: 15.2474,
    height: 15.2473,
    rx: 1.36465,
    stroke: "#73767D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6094 8.36349L13.4285 6.72285C12.9905 6.39339 12.386 6.39879 11.954 6.736L9.26966 8.83137L5.41814 4.15041C5.04322 3.69475 4.35167 3.67677 3.95359 4.11233L0.388654 8.01285",
    stroke: "#73767D",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99655,
    cy: 4.13912,
    rx: 0.920863,
    ry: 0.920858,
    fill: "#73767D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6267_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6267_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoOutline);
export default __webpack_public_path__ + "static/media/photo-outline.50d4b4057745fb52f835fee944fcb0c3.svg";
export { ForwardRef as ReactComponent };